import { render, staticRenderFns } from "./ModalAppointmentTermReplace.vue?vue&type=template&id=0ba87efc&"
import script from "./ModalAppointmentTermReplace.vue?vue&type=script&lang=js&"
export * from "./ModalAppointmentTermReplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAlert,VBtn,VChip})
